var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBulkEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 1.125L11.25 0L10.125 1.125L9 0L7.875 1.125L6.75 0L5.625 1.125L4.5 0L3.375 1.125L2.25 0V10.5H0V12.75C0 13.995 1.005 15 2.25 15H11.25C12.495 15 13.5 13.995 13.5 12.75V0L12.375 1.125ZM9 13.5H2.25C1.8375 13.5 1.5 13.1625 1.5 12.75V12H9V13.5ZM12 12.75C12 13.1625 11.6625 13.5 11.25 13.5C10.8375 13.5 10.5 13.1625 10.5 12.75V10.5H3.75V2.25H12V12.75Z",
    fill: "#FB9200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkEdit);
export default __webpack_public_path__ + "static/media/bulkEdit.60043f8bc1d4809f949309c72fde45b9.svg";
export { ForwardRef as ReactComponent };